import { useRef, useEffect } from 'react';

const useOutsideClick = (callback, excludeNodeIds = []) => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = (event) => {
      const excludeNodes = excludeNodeIds.length && document.querySelectorAll(
        excludeNodeIds.map((nodeId) => `[data-exclude-outside-click-id=${nodeId}]`)
      );

      const isExcludedContainsTarget = Array.from(excludeNodes)
        .filter((node) => node.contains(event.target));

      if (ref.current && !ref.current.contains(event.target) && !isExcludedContainsTarget.length) {
        callback(event);
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [callback, excludeNodeIds]);

  return ref;
};

export default useOutsideClick;